export default "/_next/static/fonts/tt_norms_pro_normal-d5507a67043190a13d523e1ec2d0a358.woff";